import { Component, Input } from '@angular/core';
import { DataTableColumnWaitingTime } from './data-table-column-waiting-time.config';

@Component({
  selector: 'data-table-column-waiting-time',
  imports: [],
  templateUrl: './data-table-column-waiting-time.component.html',
  styleUrl: './data-table-column-waiting-time.component.scss'
})
export class DataTableColumnWaitingTimeComponent {
  @Input() column!: DataTableColumnWaitingTime;
  @Input() item!: any;

  getWaitingTimeClass(): string {
    switch (this.column?.value(this.item)) {
      case 'GREEN':
        return 'bg-success';
      case 'YELLOW':
        return 'bg-warning';
      case 'RED':
        return 'bg-danger';
      default:
        return 'bg-danger';
    }
  }
}
